import { useState } from 'react'
import styled from 'styled-components'

import PlayerHand from './PlayerHand'
import PlayButton from './PlayButton'

const BoardWrapper = styled.div`
    display: flex;
    justify-content: space-around;
    align-items: center;
`

function PlayerBoard() {
    const [ selected, setSelected ] = useState(null)

    return(
        <BoardWrapper>
            <PlayerHand selected={selected} setSelected={setSelected}/>
            <PlayButton selected={selected}/>
        </BoardWrapper>
    )
}

export default PlayerBoard